export const types = {
  SET_TASKS: 'SET_TASKS',
  SET_TASK: 'SET_TASK',
  ADD_TASK: 'ADD_TASK',
  UPDATE_TASK: 'UPDATE_TASK',
  REMOVE_TASK: 'REMOVE_TASK',
  REMOVE_TASKS: 'REMOVE_TASKS',
  BULK_UPDATE_TASKS: 'BULK_UPDATE_TASKS',
  SET_COMMENTS: 'SET_COMMENTS',
  ADD_COMMENT: 'ADD_COMMENT',
  REMOVE_COMMENT: 'REMOVE_COMMENT',
  SET_UI_FLAG: 'SET_UI_FLAG',
  BUMP_FETCH_TASKS_REQUEST_ID: 'BUMP_FETCH_TASKS_REQUEST_ID',
};

export default {
  [types.SET_TASKS](state, tasks) {
    state.tasks = tasks;
  },
  [types.SET_TASK](state, task) {
    state.task = task;
  },
  [types.ADD_TASK](state, task) {
    state.tasks = [task, ...state.tasks];
  },
  [types.UPDATE_TASK](state, updated) {
    state.tasks = state.tasks.map(t => (t.id === updated.id ? updated : t));
    if (state.task?.id === updated.id)
      state.task = { ...state.task, ...updated };
  },
  [types.REMOVE_TASK](state, taskId) {
    state.tasks = state.tasks.filter(t => t.id !== taskId);
    if (state.task?.id === taskId) state.task = null;
  },
  [types.REMOVE_TASKS](state, ids) {
    const set = new Set(ids);
    state.tasks = state.tasks.filter(t => !set.has(t.id));
    if (state.task && set.has(state.task.id)) state.task = null;
  },
  [types.BULK_UPDATE_TASKS](state, updatedList) {
    const map = Object.fromEntries(updatedList.map(t => [t.id, t]));
    state.tasks = state.tasks.map(t => map[t.id] ?? t);
    if (state.task && map[state.task.id])
      state.task = { ...state.task, ...map[state.task.id] };
  },
  [types.SET_COMMENTS](state, comments) {
    state.comments = comments;
  },
  [types.ADD_COMMENT](state, comment) {
    state.comments = [...state.comments, comment];
  },
  [types.REMOVE_COMMENT](state, commentId) {
    state.comments = state.comments.filter(c => c.id !== commentId);
  },
  [types.SET_UI_FLAG](state, flags) {
    state.uiFlags = { ...state.uiFlags, ...flags };
  },
  [types.BUMP_FETCH_TASKS_REQUEST_ID](state) {
    state.fetchTasksRequestId += 1;
  },
};
